import { c as _c } from "react/compiler-runtime";
import { Box } from '@mui/material';
import type { PropsWithChildren, Ref } from 'react';
import { MAXIMUM_COLUMNS_MOBILE, useCreditCardCompareColumnContext } from '../../ColumnContext';
type ProductCardProps = {
  innerRef?: Ref<HTMLDivElement>;
};
export function ProductCardObserverContainer(t0) {
  const $ = _c(10);
  const {
    children,
    innerRef
  } = t0;
  const {
    index
  } = useCreditCardCompareColumnContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      xs: 1,
      md: 3
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const t2 = index > MAXIMUM_COLUMNS_MOBILE - 1 ? "none" : "block";
  let t3;
  if ($[1] !== t2) {
    t3 = {
      md: "block",
      xs: t2
    };
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== index) {
    t4 = theme => ({
      marginTop: "10px",
      borderLeft: index !== 0 ? `1px solid ${theme.palette.neutral.lighter}` : 0,
      borderTop: `1px solid ${theme.palette.neutral.lighter}`
    });
    $[3] = index;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== children || $[6] !== innerRef || $[7] !== t3 || $[8] !== t4) {
    t5 = <Box py={t1} px={3} flex={1} ref={innerRef} display={t3} sx={t4}>{children}</Box>;
    $[5] = children;
    $[6] = innerRef;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}